export default function loadCSV(url, row) {
  return new Promise((resolve, reject) => {
    require.ensure(['d3-dsv'], require => {
      const { dsvFormat } = require('d3-dsv');
      const pupu = dsvFormat('  ');
      fetch(url)
        .then(response => response.text())
        .then(text => pupu.parse(text, row))
        .then(resolve)
        .catch(e => {
          reject(e);
        });
    });
  });
}
